import React from 'react';

export const NotFound404 = () =>
    <div>
        <h1>Error 404 - Page Not Found</h1>
    </div>